// @greenlight-spec: 10-security-compliance.md
// @greenlight-spec: 16-api-conventions.md
import { initContract } from '@ts-rest/core';
import { SsoProvidersResponseSchema } from '@greenlight/shared';
import { errorResponses } from './common.js';
const c = initContract();
// Unauthenticated by design: the rendered /login page must know which
// provider(s) the org configured before any session exists (docs/10 §Login
// flow). A provider is returned only when the IdP is actually configured
// (orgs.idp_client_secret_name set by the install wizard); an unconfigured
// install yields an empty array.
export const authContract = c.router({
    listProviders: {
        method: 'GET',
        path: '/auth/providers',
        responses: {
            200: SsoProvidersResponseSchema,
            ...errorResponses,
        },
        summary: "Return the org's configured SSO provider(s) for the sign-in page (unauthenticated).",
    },
});
//# sourceMappingURL=auth.js.map